import translations from './translations'

translations.add('en', {
    description: 'Please contact with merchant shop to dissolve this problem',
    close: 'CLOSE'
})
